import { render, staticRenderFns } from "./shopWrapper.vue?vue&type=template&id=4a7139d5&scoped=true&"
import script from "./shopWrapper.vue?vue&type=script&lang=js&"
export * from "./shopWrapper.vue?vue&type=script&lang=js&"
import style0 from "./shopWrapper.vue?vue&type=style&index=0&id=4a7139d5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7139d5",
  null
  
)

export default component.exports